import initialState from "./initialState";

export function CateringRuleReducer(
  state = initialState.cateringRuleParams,
  action
) {
  switch (action.type) {
    case "SEARCH_CATERING_RULE_REQUEST":
      return action.payload;

    default:
      return state;
  }
}
